(() => {
  const page = document.querySelector('.policy-page');
  if (!page) return;

  const body = page.querySelector('.shopify-policy__body');
  const contents = page.querySelector('.policy-page__contents');
  const list = page.querySelector('.policy-page__anchors');
  if (!body || !contents || !list) return;

  const desktop = window.matchMedia('(min-width: 990px)');
  const sidebar = page.querySelector('.policy-page__sidebar');
  const layout = page.querySelector('.policy-page__layout');
  const navigation = page.querySelector('.policy-page__navigation');
  const updateLayout = () => {
    // Move the same navigation so keyboard order follows the mobile reading order.
    if (navigation && sidebar && layout) {
      (desktop.matches ? sidebar : layout).appendChild(navigation);
    }
    contents.open = desktop.matches;
  };
  updateLayout();
  desktop.addEventListener('change', updateLayout);

  // Keep the original policy HTML, including existing anchor IDs, intact.
  const headings = Array.from(body.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim());
  const primaryHeadings = headings.some((heading) => heading.tagName === 'H2')
    ? headings.filter((heading) => heading.tagName === 'H2')
    : headings;

  primaryHeadings.forEach((heading, index) => {
    if (!heading.id) {
      let id = `policy-section-${index + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    item.appendChild(link);
    list.appendChild(item);
  });

  if (primaryHeadings.length > 1) {
    contents.hidden = false;
    list.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      list.querySelectorAll('a').forEach((anchor) => anchor.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'location');
      if (!desktop.matches) contents.open = false;
    });
  }

  body.querySelectorAll('table').forEach((table) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'policy-page__table';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    const heading = primaryHeadings.filter((item) => item.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
    if (heading) wrapper.setAttribute('aria-labelledby', heading.id);
    else wrapper.setAttribute('aria-label', page.querySelector('h1')?.textContent.trim() || document.title);
    table.before(wrapper);
    wrapper.appendChild(table);
  });
})();
